import React from 'react';

export function useLoadingIds() {
	const [loadingIds, setLoadingIds] = React.useState([]);

	const idIsLoading = React.useCallback((id) => loadingIds.includes(id), [loadingIds]);

	const setLoadingId = React.useCallback((id) => {
		setLoadingIds((ids) => ids.includes(id) ? ids : [...ids, id]);
	}, []);

	const setLoadedId = React.useCallback((id) => {
		setLoadingIds((ids) => ids.filter(v => v !== id));
	}, []);

	return ({
		idIsLoading,
		setLoadingId,
		setLoadedId,
	});
}
